<template>
  <div>
    <h2>Login</h2>
    <form @submit.prevent="login">
      <label><input v-model="email" placeholder="email"></label><br>
      <label><input v-model="pass" placeholder="password" type="password"></label><br>
      <button type="submit">login</button>
      <p v-if="error" class="error">Bad login information</p>
    </form>
  </div>
</template>

<script>
  import auth from '../auth'

  export default {
    name: "Login",
    data () {
      return {
        email: 'your@mail.com',
        pass: '',
        error: false,
      }
    },
    methods: {
      async login() {
        if (!await auth.login(this.email, this.pass)) {
          this.error = true
        } else {
          await this.$router.push({name: 'Books'})
        }
      }
    }
  }
</script>

<style>
  .error {
    color: red;
  }
</style>
